const filterOutEmailPassword = (string) => {
	const result = string.replace(/"Email":"(.*?)@(.*?).(.*?)"/ig, '')
		.replace(/[A-Z0-9._%+-.*?]+@(.*?)\.[A-Z0-9._%+-.*?]+/ig, '')
		.replace(/"Password":"(.*?)"/ig, '');
	return result;
}

export default filterOutEmailPassword;